<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="toc">
<div epub:type="frontmatter">
<section epub:type="division">
<h1 class="toc_head"><a id="pagevii"></a>CONTENTS</h1>
<p class="toc_chap"><a href="#/Text/9781454926474_epub_itr_r1#itr"><em>Introduction</em></a></p>
<p class="toc_chap1"><a href="#/Text/9781454926474_epub_p01_r1"><span class="csans_big"><strong>PART 1: SALATO</strong></span> <span class="csans_small"><strong>(SAVORY)</strong></span></a></p>
<p class="toc_chap"><a href="#/Text/9781454926474_epub_c01_r1"><strong><span class="sans">CHAPTER 1:</span></strong> <em>Antipasti</em> (Appetizers)</a></p>
<p class="toc_chap"><span href="#/Text/9781454926474_epub_c02_r1" title="Link target outside of Sample"><strong><span class="sans">CHAPTER 2:</span></strong> <em>Primi</em> (First Courses)</span></p>
<p class="toc_chap"><span href="#/Text/9781454926474_epub_c03_r1" title="Link target outside of Sample"><strong><span class="sans">CHAPTER 3:</span></strong> <em>Secondi</em> (Main Courses)</span></p>
<p class="toc_chap"><span href="#/Text/9781454926474_epub_c04_r1" title="Link target outside of Sample"><strong><span class="sans">CHAPTER 4:</span></strong> <em>Zuppe</em> (Soups)</span></p>
<p class="toc_chap"><span href="#/Text/9781454926474_epub_c05_r1" title="Link target outside of Sample"><strong><span class="sans">CHAPTER 5:</span></strong> <em>Insalate Fredde</em> (Cold Salads)</span></p>
<p class="toc_chap"><span href="#/Text/9781454926474_epub_c06_r1" title="Link target outside of Sample"><strong><span class="sans">CHAPTER 6:</span></strong> Pizzas</span></p>
<p class="toc_chap"><span href="#/Text/9781454926474_epub_c07_r1" title="Link target outside of Sample"><strong><span class="sans">CHAPTER 7:</span></strong> <em>Contorni</em> (Sides)</span></p>
<p class="toc_chap1"><span href="#/Text/9781454926474_epub_p02_r1" title="Link target outside of Sample"><span class="csans_big"><strong>PART 2: DOLCE</strong></span> <span class="csans_small"><strong>(SWEET)</strong></span></span></p>
<p class="toc_chap"><span href="#/Text/9781454926474_epub_c08_r1" title="Link target outside of Sample"><strong><span class="sans">CHAPTER 8:</span></strong> <em>Dolce</em> (Desserts)</span></p>
<p class="toc_chap"><span href="#/Text/9781454926474_epub_c09_r1" title="Link target outside of Sample"><strong><span class="sans">CHAPTER 9:</span></strong> <em>L’Arte Del Gelato</em> (The Art of Gelato)</span></p>
<p class="toc_chap1"><span href="#/Text/9781454926474_epub_ack_r1" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454926474_epub_toc_r1.vue?a9c8f59a